import "./styles/main.css";

import { initCursor } from "./cursor";
import { initScrollProgress } from "./scroll";
import { initReveal } from "./reveal";
import { initLang } from "./lang";
import { initLazyVideos } from "./lazyVideos";

function boot(): void {
  initCursor();
  initScrollProgress();
  initReveal(null);
  initLang(null);
  initLazyVideos();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
